import { ContentPanel } from "./shared";
import PasswordGate from "./PasswordGate";
import Access from "./Access";
import EmailPreviews from "./EmailPreviews";
import type { Artist } from "../data";
import { ExternalLink } from "lucide-react";

interface Props {
  selectedArtist: Artist;
}

export default function AdminSettings({ selectedArtist }: Props) {
  return (
    <div className="space-stack">
      <ContentPanel title="Settings" eyebrow="Portal">
        <div className="settings-list">
          <div>
            <strong>Domain</strong>
            <span>artists.johnsonboibeats.com</span>
          </div>
          <div>
            <strong>Booking page</strong>
            <span>
              <a
                className="settings-inline-link"
                href="https://johnsonboibeats.com/book"
                rel="noreferrer"
                target="_blank"
              >
                Open booking page
                <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </span>
          </div>
        </div>
      </ContentPanel>
      <PasswordGate description="Update the password used for this portal account." />
      <Access selectedArtist={selectedArtist} />
      <EmailPreviews />
    </div>
  );
}
